/**
 * Predictive-search results height fix.
 *
 * Dawn's `PredictiveSearch#getResultsMaxHeight()` sizes the results panel as
 * `window.innerHeight - <bottom of .section-header>`. That is right for the header
 * search modal, which opens flush beneath the header, but Kett also renders a search
 * block inside the homepage image banner (`sections/image-banner.liquid`), and that
 * input sits several hundred pixels further down the page. There the header-derived
 * figure overshoots the space that actually exists by roughly 240px on a phone, so
 * the panel is handed more height than fits, runs past the bottom of the viewport,
 * and — because its own `overflow-y: auto` never engages at that height — the lower
 * results cannot be reached by scrolling the panel.
 *
 * The panel is absolutely positioned directly below its `.field`, so the usable
 * height is the gap between that field's bottom edge and the bottom of the viewport.
 * `visualViewport` is preferred where available so an open on-screen keyboard is
 * accounted for; iOS Safari does not shrink `window.innerHeight` for the keyboard.
 *
 * This lives outside `assets/predictive-search.js` so Dawn's own files stay
 * byte-identical to upstream — see "Updating from Dawn" in README.md.
 */
(() => {
  const PredictiveSearch = customElements.get('predictive-search');
  if (!PredictiveSearch) return;

  PredictiveSearch.prototype.getResultsMaxHeight = function getResultsMaxHeight() {
    const anchor = this.input?.closest('.field') || this.input || this;
    const viewportHeight = window.visualViewport?.height || window.innerHeight;
    const maxHeight = viewportHeight - anchor.getBoundingClientRect().bottom;

    // Dawn's open() reads `this.resultsMaxHeight` first and only falls back to this
    // method when it is falsy — but it assigns that cached value raw, without a unit,
    // so a cached number produces invalid CSS and is silently dropped. Leaving the
    // cache falsy keeps open() on the fallback path, so every open re-measures with
    // a unit. Re-measuring is also what we want: the field's position on screen
    // changes as the page scrolls.
    this.resultsMaxHeight = false;

    return maxHeight;
  };
})();
